function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.78125 0.734375L6.58984 0.953125C6.53516 1.00781 6.50781 1.08073 6.50781 1.17188C6.50781 1.26302 6.53516 1.34505 6.58984 1.41797L11.4844 6.28516H1.20312C1.11198 6.28516 1.02995 6.32161 0.957031 6.39453C0.902344 6.44922 0.875 6.52214 0.875 6.61328V6.88672C0.875 6.97786 0.902344 7.0599 0.957031 7.13281C1.02995 7.1875 1.11198 7.21484 1.20312 7.21484H11.4844L6.58984 12.082C6.53516 12.1549 6.50781 12.237 6.50781 12.3281C6.50781 12.4193 6.53516 12.4922 6.58984 12.5469L6.78125 12.7656C6.85417 12.8203 6.9362 12.8477 7.02734 12.8477C7.11849 12.8477 7.19141 12.8203 7.24609 12.7656L13.0156 6.96875C13.0885 6.91406 13.125 6.84115 13.125 6.75C13.125 6.65885 13.0885 6.58594 13.0156 6.53125L7.24609 0.734375C7.19141 0.679688 7.11849 0.652344 7.02734 0.652344C6.9362 0.652344 6.85417 0.679688 6.78125 0.734375Z",
  fill: "currentColor"
});

var SvgArrowRight = function SvgArrowRight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 13",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgArrowRight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-right.f2d8b360.svg";
export { ForwardRef as ReactComponent };